// removed by extract-text-webpack-plugin
module.exports = {"container":"ky_g","label":"ky_g8","labelActive":"ky_kz ky_g8","country":"ky_k0"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/PlacepickerPreset/styles.module.css
// module id = 477
// module chunks = 27